import PubSub from "underpub-js";

var ListingTestimonials = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingTestimonials',
	};

	$.extend(true, this.options, options);

};

ListingTestimonials.prototype.init = function() {

	var self = this;

};

export default ListingTestimonials;
